import { useRef, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Loader2, Upload } from "lucide-react";
import { tarifasApi, errMsg } from "./api";

const AUTO = "__auto__";
const ACCEPT = ".pdf,.xlsx,.xlsm,.xls,.csv,.txt,.docx,.png,.jpg,.jpeg,.webp,.heic,.heif,.tif,.tiff";

export const UploadBox = ({ providers, onUploaded }) => {
  const input = useRef(null);
  const [provider, setProvider] = useState(AUTO);
  const [progress, setProgress] = useState(null);

  const onFiles = async (e) => {
    const files = Array.from(e.target.files || []);
    e.target.value = "";
    if (!files.length) return;
    let ok = 0;
    for (const [i, file] of files.entries()) {
      setProgress({ name: file.name, index: i + 1, total: files.length, pct: 0 });
      try {
        await tarifasApi.uploadFile(file, provider === AUTO ? null : provider, (ev) => setProgress((p) => ({ ...p, pct: ev.total ? Math.round((ev.loaded / ev.total) * 100) : 0 })));
        ok += 1;
      } catch (err) {
        toast.error(`${file.name}: ${errMsg(err, "no se pudo subir")}`);
      }
    }
    setProgress(null);
    if (ok) {
      toast.success(`${ok} archivo(s) subido(s). Asigna el proveedor si hace falta y pulsa Procesar.`);
      onUploaded?.();
    }
  };

  return (
    <div className="rounded-md border border-dashed p-3 flex flex-wrap items-center gap-2 bg-muted/30" data-testid="upload-box">
      <Upload className="h-4 w-4 text-muted-foreground" />
      <div className="flex-1 min-w-48">
        <p className="text-sm font-medium">Importar tarifas desde el ordenador</p>
        <p className="text-xs text-muted-foreground">PDF, Excel, Word (.docx), CSV o fotos (JPG/PNG/HEIC). Las fotos y los PDF escaneados se leen con IA de visión. Máx. 25 MB por archivo.</p>
      </div>
      <Select value={provider} onValueChange={setProvider}>
        <SelectTrigger data-testid="upload-provider" className="h-8 w-52 rounded-md text-xs"><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value={AUTO}>Proveedor: detectar por nombre</SelectItem>
          {providers.map((p) => <SelectItem key={p.id} value={p.id}>{p.name}</SelectItem>)}
        </SelectContent>
      </Select>
      <input ref={input} type="file" multiple accept={ACCEPT} className="hidden" onChange={onFiles} data-testid="upload-input" />
      <Button data-testid="upload-button" size="sm" className="rounded-md" onClick={() => input.current?.click()} disabled={!!progress}>
        {progress ? <Loader2 className="h-3 w-3 animate-spin mr-1" /> : <Upload className="h-3 w-3 mr-1" />} Elegir archivos…
      </Button>
      {progress && <p className="w-full text-xs text-violet-700" data-testid="upload-progress">Subiendo {progress.index}/{progress.total}: {progress.name} — {progress.pct}%</p>}
    </div>
  );
};
